<template>
    <div class="basic_wrap">
        <div class="page_header">
            <div class="header_inner">
                <div class="back_left" @click="$router.back()"></div>
                <div class="big_tit">余额充值</div>
            </div>
        </div>
        <div class="content_box">
            <div class="balance_card">
                <p class="balance_label">商城可用余额(元)</p>
                <p class="balance_num numberFont"><span>¥</span>{{ money || '0.00' }}</p>
            </div>

            <div class="recharge_card">
                <div class="input_wrap">
                    <span class="unit">¥</span>
                    <input
                        type="number"
                        v-model="rechargeMoney"
                        placeholder="请输入充值金额"
                        @input="onInput"
                    />
                </div>
                <div class="input_wrap">
                    <input
                        type="password"
                        v-model="payPwd"
                        maxlength="20"
                        placeholder="请输入支付密码验证"
                    />
                </div>
                <p class="recharge_tip">提交后请等待平台审核，审核通过后金额将自动到账</p>
                <div class="submit_btn" :class="{ disabled: !rechargeMoney || !payPwd }" @click="submitRecharge">提交充值申请</div>
            </div>

            <div class="records_box">
                <div class="records_tit">充值记录</div>
                <template v-if="records.length">
                    <div class="records_item" v-for="(v, k) in records" :key="k">
                        <div class="r_left">
                            <p class="r_money">¥{{ v.money }}</p>
                            <p class="r_order">单号：{{ v.orderid }}</p>
                            <p class="r_time">{{ v.time }}</p>
                        </div>
                        <p class="r_status" :class="'status_' + v.status">{{ statusText(v.status) }}</p>
                    </div>
                </template>
                <div class="records_empty" v-else>暂无充值记录</div>
            </div>
        </div>
    </div>
</template>

<script>

    import Fetch from '../../utils/fetch';
    export default {
        name: "recharge",
        data() {
            return {
                money: '0.00',
                rechargeMoney: '',
                payPwd: '',
                records: [],
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/user/recharge_list').then((r) => {
                    this.money = r.data.money;
                    this.records = r.data.list || [];
                });
            },
            onInput() {
                var val = this.rechargeMoney.replace(/[^\d.]/g, '');
                var parts = val.split('.');
                if (parts.length > 2) {
                    val = parts[0] + '.' + parts[1];
                }
                if (parts[1] && parts[1].length > 2) {
                    val = parts[0] + '.' + parts[1].slice(0, 2);
                }
                this.rechargeMoney = val;
            },
            submitRecharge() {
                var money = parseFloat(this.rechargeMoney);
                if (!money || money <= 0) {
                    this.$toast('请输入正确的充值金额');
                    return;
                }
                if (!this.payPwd) {
                    this.$toast('请输入支付密码');
                    return;
                }
                Fetch('/user/recharge_apply', {
                    money: money,
                    passwd: this.payPwd
                }).then((r) => {
                    this.$toast(r.info || '充值申请已提交');
                    this.rechargeMoney = '';
                    this.payPwd = '';
                    this.start();
                });
            },
            statusText(status) {
                status = String(status);
                if (status == '1') return '已到账';
                if (status == '2') return '已拒绝';
                return '待审核';
            }
        }
    };
</script>

<style lang="less" scoped>
    .basic_wrap {
        padding-top: 60px;
        min-height: 100vh;
        background: #F6F7FB;
    }

    .page_header {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 500px;
        z-index: 20;
        background: url(../../assets/images/red_bg.png) no-repeat center center;
        background-size: 100% 100%;
    }

    .header_inner {
        position: relative;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .back_left {
        position: absolute;
        left: 0;
        top: 14px;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        background: url(../images/item/back.png) no-repeat center center;
        background-size: auto 100%;
    }

    .big_tit {
        font-size: 17px;
        font-weight: 600;
        color: #FFFFFF;
    }

    .content_box {
        width: 100%;
        max-width: 500px;
        margin: 0 auto;
        padding: 12px 12px 30px;
        box-sizing: border-box;
    }

    .balance_card {
        background: #fff;
        border-radius: 9px;
        padding: 22px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 0 2px 9px 2px rgba(160, 160, 160, .15);
    }

    .balance_card .balance_label {
        font-size: 13px;
        color: #999;
        line-height: 18px;
        margin-bottom: 10px;
    }

    .balance_card .balance_num {
        font-size: 38px;
        font-weight: bold;
        color: #E96259;
        line-height: 48px;
    }

    .balance_card .balance_num span {
        font-size: 18px;
        margin-right: 4px;
    }

    .recharge_card {
        margin-top: 12px;
        background: #fff;
        border-radius: 9px;
        box-shadow: 0 2px 9px 2px rgba(160, 160, 160, .15);
        padding: 20px 16px;
    }

    .input_wrap {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #F0F0F0;
        padding: 4px 0 12px;
    }

    .input_wrap .unit {
        font-size: 24px;
        font-weight: bold;
        color: #333;
        margin-right: 6px;
    }

    .input_wrap input {
        flex: 1;
        height: 40px;
        border: none;
        outline: none;
        font-size: 28px;
        font-weight: bold;
        color: #333;
        background: transparent;
    }

    .input_wrap input::placeholder {
        font-size: 15px;
        font-weight: normal;
        color: #c8c8c8;
    }

    .recharge_tip {
        margin-top: 12px;
        font-size: 12px;
        color: #999;
        line-height: 17px;
    }

    .submit_btn {
        margin-top: 18px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        font-size: 15px;
        font-weight: 600;
        color: #fff;
        background: linear-gradient(90deg, #E96259, #F5A623);
        border-radius: 21px;
    }

    .submit_btn.disabled {
        opacity: .5;
    }

    .records_box {
        margin-top: 12px;
        background: #fff;
        border-radius: 9px;
        box-shadow: 0 2px 9px 2px rgba(160, 160, 160, .15);
        padding: 0 14px;
        overflow: hidden;
    }

    .records_box .records_tit {
        font-size: 14px;
        font-weight: bold;
        color: #333;
        line-height: 44px;
        border-bottom: 1px solid #F6F6F6;
    }

    .records_box .records_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 0;
        border-bottom: 1px solid #F6F6F6;
    }

    .records_box .records_item:last-child {
        border-bottom: none;
    }

    .records_item .r_left {
        flex: 1;
        min-width: 0;
    }

    .records_item .r_money {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        line-height: 22px;
    }

    .records_item .r_order,
    .records_item .r_time {
        font-size: 12px;
        color: #999;
        line-height: 17px;
        margin-top: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .records_item .r_status {
        flex-shrink: 0;
        margin-left: 12px;
        font-size: 13px;
        font-weight: 600;
    }

    .records_item .r_status.status_0 {
        color: #F5A623;
    }

    .records_item .r_status.status_1 {
        color: #E96259;
    }

    .records_item .r_status.status_2 {
        color: #999;
    }

    .records_box .records_empty {
        text-align: center;
        color: #999;
        font-size: 13px;
        padding: 40px 0;
    }
</style>
